import React from 'react';

import './styles.css';

export default function ListInfos(props) {
    return (
        <div className='list-infos-component'>
            <p className='tittle'>{props.tittle ? props.tittle : "Lista"}</p>
            <p className='counter'>
                {props.counter} {props.counter === 1 && props.singleCounterName ? props.singleCounterName : props.counterName}
            </p>
        </div>
    )
}